import React from 'react';
import { ImageIcon, StarIcon } from 'lucide-react';
import { Container } from './Container';
import { SectionHeading } from './SectionHeading';
import { reviews, type Review } from '../data/reviews';
function ReviewCard({
  review
}: {
  review: Review;
}) {
  const isEmpty = !review.image && !review.text;
  if (isEmpty) {
    return <li className="flex min-h-[230px] flex-col justify-between rounded-card border border-dashed border-hairline bg-white/70 p-4 sm:min-h-[300px] sm:p-5" data-id="element-202" data-mp="2rcd0zg355dwd">
        <div className="flex flex-1 flex-col items-center justify-center text-center" data-id="element-203" data-mp="30ayegwtra2qa">
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-paper" data-id="element-204" data-mp="352gg7n3ls7cb">
            <ImageIcon className="h-5 w-5 text-muted/50" aria-hidden="true" data-id="element-205" data-mp="3a19sxdb2fubf" />
          </span>
          <p className="mt-3.5 font-display text-[11px] font-bold uppercase tracking-[0.16em] text-muted" data-id="element-206" data-mp="3f0cpsagw6u8b">
            Real review slot
          </p>
          <p className="mt-2 text-[13px] leading-[1.5] text-muted/80 sm:text-[14px]" data-id="element-207" data-mp="3k08te8logjnc">
            {review.slotHint}
          </p>
        </div>
        <p className="mt-3 text-center text-[12px] leading-[1.45] text-muted/70" data-id="element-208" data-mp="2rab1gkppbi1u">
          Add the original screenshot or customer photo — no text is invented here.
        </p>
      </li>;
  }
  return <li className="flex flex-col overflow-hidden rounded-card border border-hairline bg-white shadow-paper" data-id="element-209" data-mp="2dcw7d2oi6m3j">
      {review.stars !== null && <div className="flex items-center gap-0.5 px-4 pt-4 sm:px-5 sm:pt-5" aria-label={`${review.stars} out of 5 stars`} data-id="element-210" data-mp="3a1u1qjscci06">
          {Array.from({
        length: review.stars
      }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-sun text-sun" aria-hidden="true" data-id="element-211" data-mp="30bizr2s7wivx" data-mpi={index} />)}
        </div>}

      {review.image && <a href={review.image} target="_blank" rel="noreferrer" className="focus-ring mt-3 block px-4 sm:px-5" data-id="element-212" data-mp="3stwma683sifp">
          <img src={review.image} alt={review.text ? `Customer review: ${review.text.slice(0, 60)}` : 'Customer review'} loading="lazy" className="w-full rounded-[12px] border border-hairline object-cover" data-id="element-213" data-mp="3o13flct2r00z" />
        </a>}

      <div className="flex flex-1 flex-col px-4 py-4 sm:px-5 sm:py-5" data-id="element-214" data-mp="1cdi5rist4h84">
        {review.text && <p className="text-[15px] leading-[1.6] text-inkSoft sm:text-[16px]" data-id="element-215" data-mp="1hckzi73c710s">{review.text}</p>}

        <div className="mt-3.5 flex flex-wrap items-center gap-x-2.5 gap-y-1 text-[13px] text-muted sm:text-[14px]" data-id="element-216" data-mp="13gzbo38uan9y">
          {review.name && <span className="font-semibold text-ink" data-id="element-217" data-mp="th8iq5zxggbz">{review.name}</span>}
          {review.verified && <span data-id="element-218" data-mp="yfjqmb6nwgrk">Verified Customer</span>}
          {review.date && <span data-id="element-219" data-mp="yg1wlzj4m9co">{review.date}</span>}
        </div>

        {review.source && <p className="mt-2 text-[12px] leading-[1.45] text-muted/80" data-id="element-220" data-mp="2nw1cs0l5wz1t">{review.source}</p>}
      </div>
    </li>;
}
export function Reviews() {
  const firstBlock = reviews.slice(0, 6);
  const restBlock = reviews.slice(6);
  return <section aria-labelledby="reviews-heading" className="bg-paper py-16 sm:py-24" data-id="element-221" data-mp="c7eduy71nt88">
      <Container narrow data-id="element-222" data-mp="c5bg1rzngvsy">
        <SectionHeading id="reviews-heading" title={<>
              See What <span className="pop-sm-orange" data-id="element-224" data-mp="m5u5d29zh4i9">Parents Are Saying</span>
            </>} subtitle="Real families. Real projects. Real moments of creativity." data-id="element-223" data-mp="qw0ssysreiyx" />

        <ul className="mt-11 grid grid-cols-2 gap-3 sm:mt-14 sm:gap-5" data-id="element-225" data-mp="vvdq6dh9b8fr">
          {firstBlock.map(review => <ReviewCard key={review.id} review={review} data-id="element-226" data-mp="19uwko3h5al9l" />)}
        </ul>

        {restBlock.length > 0 && <>
            <p className="mx-auto my-11 max-w-[560px] text-center font-hand text-[24px] leading-snug text-ink sm:my-14 sm:text-[30px]" data-id="element-227" data-mp="14xd8d940cika">
              From a simple sheet of paper…
              <span className="block text-muted" data-id="element-228" data-mp="36o87a9tigxv8">
                to something they’re proud to say they built themselves.
              </span>
            </p>

            <ul className="grid grid-cols-2 gap-3 sm:gap-5" data-id="element-229" data-mp="386yc714mxp5f">
              {restBlock.map(review => <ReviewCard key={review.id} review={review} data-id="element-230" data-mp="3i2ryhc85ox0e" />)}
            </ul>
          </>}
      </Container>
    </section>;
}